export const importNavShortcuts = () => import(
  '../../_components/NavShortcuts.html'
).then(mod => mod.default)
